import React, { useState } from "react";


export default function PaymentDialog({ total, onConfirm }) {
    const [cash, setCash] = useState(0);
    const [momo, setMomo] = useState(0);
    const [card, setCard] = useState(0);


    const sum = Number(cash) + Number(momo) + Number(card);
    const missing = Math.max(0, total - sum);
    const change = Math.max(0, sum - total);


    return (
        <div className="card mt-3">
            <div className="card-body">
                <h6 className="card-title">Encaissement</h6>
                <div className="row g-2">
                    <div className="col-12 col-md-4">
                        <label className="form-label">Espèces</label>
                        <input type="number" className="form-control" value={cash} onChange={(e) => setCash(Number(e.target.value || 0))} />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Mobile Money</label>
                        <input type="number" className="form-control" value={momo} onChange={(e) => setMomo(Number(e.target.value || 0))} />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Carte</label>
                        <input type="number" className="form-control" value={card} onChange={(e) => setCard(Number(e.target.value || 0))} />
                    </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                        <div className="small text-muted">Manquant: {missing.toLocaleString()} XOF</div>
                        <div className="small text-muted">Rendu: {change.toLocaleString()} XOF</div>
                    </div>
                    <button className="btn btn-dark" disabled={sum < total} onClick={() => onConfirm([
                        cash > 0 ? { method: 'cash', amount: cash } : null,
                        momo > 0 ? { method: 'momo', amount: momo } : null,
                        card > 0 ? { method: 'card', amount: card } : null,
                    ].filter(Boolean))}>Valider le paiement</button>
                </div>
            </div>
        </div>
    );
}